import React from 'react';
import { Card } from 'react-bootstrap';

interface TrendInfo {
  label: string;
  value: string;
  variant?: 'success' | 'danger' | 'secondary';
}

export interface StatsCardProps {
  title: string;
  value: string;
  helper?: string;
  trend?: TrendInfo;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  helper,
  trend,
}) => (
  <Card className="h-100 shadow-sm border-0">
    <Card.Body>
      <Card.Title className="text-muted text-uppercase fs-6">{title}</Card.Title>
      <Card.Text className="display-6 fw-semibold">{value}</Card.Text>
      {helper && <Card.Text className="text-muted mb-2">{helper}</Card.Text>}
      {trend && (
        <span className={`badge bg-${trend.variant ?? 'secondary'}`}>
          {trend.value} · {trend.label}
        </span>
      )}
    </Card.Body>
  </Card>
);
